<template>
  <!-- Inline actions -->
  <td style="width: 2rem">
    <div class="align-middle d-inline-flex flex-shrink-0">
      <IconButton
        v-if="updatableInline"
        icon-name="material-symbols:edit-square-outline"
        class="text-primary"
        @click="$emit('updateInline')"
      />
      <template v-if="deletableInline">
        <IconButton
          icon-name="material-symbols:delete-outline"
          class="text-danger"
          :loading="getLoadingRow(row.id)"
          :disabled="getLoadingRow(row.id)"
          @click="$emit('deleteInline')"
        />
      </template>
      <slot name="extraActions" :rowid="row.id" />
    </div>
  </td>
</template>
<script setup lang="ts">
const props = defineProps<{
  row: any;
  loadingCol?: string;
  loadingRow?: string;
  updatableInline?: boolean;
  deletableInline?: boolean;
}>();
defineEmits<{
  updateInline: [];
  deleteInline: [];
}>();
const getLoadingRow = (id: string) => id === props.loadingRow && props.loadingCol === undefined;
</script>
